import styled from 'styled-components';

export const BlogTitleH1 = styled.div`
  display: contents;

  > h1 {
    font-style: normal;
    font-weight: 400;
    font-size: 2.3rem;
    line-height: 1.5;
    color: #475157;
    margin: 0 0 0.5rem;
  }
`;
export const BlogTitleH2 = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 1.6483rem;
  line-height: 1.5;
  margin: 0 0 0.5rem;

  a {
    color: #475157;
  }
`;

export const PostImg = styled.img`
  border-radius: 0.5rem;
  margin: 0 0 2rem;
`;

export const BlogArticle = styled.article`
  margin: 0 0 4.375rem;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Left = styled.div`
  max-width: 100%;
  @media (min-width: 1440px) {
    margin: unset;
    max-width: 44.625rem;
  }
  @media (max-width: 768px) {
    margin: 0;
    width: 100%;
    max-width: 100%;
  }
`;
